import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  background-color: #f78e1e;
  color: #fff !important;

  @media (min-width: ${BREAKPOINTS.phone}) {
    padding: 8px 16px;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 8px 32px;
    width: 100%;
  }
`;

export const Title = styled.h2`
  font-weight: 600;
  color: #fff !important;
  margin: 0;
  padding: 0;
  text-align: left;
  width: 100%;
  font-style: normal;
  line-height: 32px;

  @media (min-width: ${BREAKPOINTS.phone}) {
    font-size: 1rem;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    font-size: 1.4375rem;
  }
`;

export const BackText = styled.span`
  @media (max-width: 600px) {
    display: none !important;
  }
`;

export const DetailsContainer = styled.div`
  background-color: #f5f5f5;
  display: flex;
  gap: 24px;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 24px 32px 24px 32px;
  }
`;

export const GfpOfferDivider = styled.div`
  border-bottom: 1px solid #d9d9d9;
`;

export const WarningLabel = styled.p`
  padding: 0 8px;
`;
